import { palette } from './palette';
import homeIcon from 'assets/images/home-icon.svg';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    // Radio buttons in login page
    '& .MuiRadio-root': {
      color: `${palette.background.border} !important`,
      '&.Mui-checked': {
        color: `${palette.background.border} !important`,
      },
      '& .MuiSvgIcon-root': {
        color: `${palette.background.border} !important`,
      },
    },
    '& .MuiRadio-colorPrimary.Mui-checked': {
      color: `${palette.background.border} !important`,
    },
    '& .section-header__subtitle': {
      fontSize: '18px !important',
      color: `${palette.text.tertiary} !important`,
      '@media (max-width: 1024px)': {
        overflowWrap: 'anywhere',
        wordBreak: 'break-word',
      },
    },
    // Mobile: hero left column is hidden but the right Section keeps flex-basis auto, so the column
    // stays narrow and left-aligned. Grow it to full width and center inner login content.
    '& .section-header': {
      '@media (max-width: 1024px)': {
        textAlign: 'center',
      },
    },
    '& .login-logo-container': {
      '@media (max-width: 1024px)': {
        textAlign: 'center',
      },
    },
    '& .login-form-container': {
      '@media (max-width: 1024px)': {
        width: '100%',
        maxWidth: '500px',
        marginLeft: 'auto',
        marginRight: 'auto',
        boxSizing: 'border-box',
      },
    },
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      minHeight: `unset !important`,
      '@media (max-width: 1024px)': {
        justifyContent: 'center',
      },
      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
      '& .hero-shaped__right-side': {
        '@media (max-width: 1024px)': {
          flex: '1 1 100%',
          maxWidth: '100%',
          width: '100%',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        },
      },
    },
    // Login "Change email" uses Mui text primary button; global MuiButton ::after + label padding clips the label.
    '& .signin-other-link': {
      flexShrink: 0,
      overflow: 'visible',
      '& .MuiButton-label': {
        paddingRight: '40px !important',
        overflow: 'visible',
        whiteSpace: 'nowrap',
      },
    },
  },


  '.header-wrapper': {
    background: `${palette.text.highlight} !important`,
    padding: '8px 16px',
    '& .MuiToolbar-root': {
      minHeight: '72px',
    }
  },

  '& .promition-dialogue': {
    '& .promo-spinner': {
      color: palette.text.highlight,
    },
  },

  '.affordabledenturesplans-container': {
    backgroundColor: palette.background.fill,
    '& .normal-text': {
      fontWeight: 300,
    },

    '& .logo-image': {
      width: '100%',
    },

    '& .coupon-container': {
      top: '88px !important',
    },

    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section,.faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
    {
      background: 'none !important',
      color: palette.text.primary,
      '& h1,& h2,& h3,& h4,& p': {
        color: palette.text.primary,
      },
      '& .hero-link-button': {
        backgroundColor: palette.secondary.main,
      },
    },

    '& .subscription-wrapper, .checkout-outer-container, .addonsWrapper, .plan-selection-container':
    {
      '& .MuiSwitch-thumb': {
        background: palette.text.highlight,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.secondary.main,
      },
      '& .MuiSwitch-track': {
        border: 'none',
        background: palette.secondary.main,
      },
    },

    '& .locale-container': {
      background: palette.background.ribbon,
      /* Align inner toolbar with .app-main-content gutters + hero max width (MFE uses 1600px). */
      '& .locale-toolbar': {
        maxWidth: '1520px !important',
      },
      /* MFE Localebar select column uses justify-end; center language control on phones */
      '@media (max-width: 600px)': {
        '& .locale-toolbar': {
          paddingBottom: '12px !important',
          boxSizing: 'border-box',
        },
        '& .locale-select-column': {
          display: 'flex',
          justifyContent: 'center !important',
          width: '100%',
        },
      },
    },

    '& .locale-column': {
      '@media (max-width: 600px)': {
        textAlign: 'center !important',
      },
      '& .locale-title': {
        fontSize: '1.5rem !important',
        fontFamily: "'Eighties Comeback', sans-serif !important",
        fontWeight: '500 !important',
        color: palette.text.primary,
      },
      '& .locale-subtitle': {
        fontSize: '0.75rem !important',
        fontFamily: 'Europa !important',
        fontWeight: '500 !important',
        color: palette.text.primary,
        '@media (max-width: 600px)': {
          fontSize: '0.65rem !important',
        },
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      '& .hero-home-button': {
        '&::after': {
          backgroundImage: `url(${homeIcon}) !important`
        },
      },
      /* Fixed locale bar with language hint (~110px); keep content below it. */
      paddingInline: '80px !important',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: palette.background.fill,
      '@media (min-width: 900px) and (max-width: 1300px)': {
        paddingInline: '60px !important',
      },
      '@media (min-width: 600px) and (max-width: 900px)': {
        paddingInline: '48px !important',
      },
      '@media (max-width: 600px)': {
        paddingInline: '24px !important',
      },
    },

    '& .home-hero-wrapper': {
      paddingTop: '166px !important',
      paddingBottom: '64px !important',
      background: 'none !important',
      '@media (min-width: 900px) and (max-width: 1024px)': {
        marginBottom: '64px !important',
      },
      '@media (min-width: 1441px)': {
        marginBottom: '64px !important',
      },
      '@media (max-width: 600px)': {
        paddingTop: '200px !important',
      },
      '& .section-alternate': {
        maxWidth: '1440px !important',
      },
      '& .section-alternate__content': {
        backgroundColor: palette.background.main,
        borderRadius: 24,
        padding: '0px 0px !important',
        maxWidth: '1440px !important',
        '& .hero-section-grid': {
          '@media (max-width: 900px) and (min-width: 600px)': {
            flexDirection: 'column',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          },
          '& .hero-left-section': {
            maxWidth: '600px !important',
            '@media (max-width: 900px) and (min-width: 600px)': {
              padding: '60px 0px !important',
            },
          },
          '& .hero-right-section': {
            maxWidth: '600px !important',
          },
          display: 'flex',
          justifyContent: 'space-between',
        },
      },

      '& .hero-section-alternate': {
        height: 'auto !important',
        paddingBottom: 0,
        paddingInline: '0px !important',

        '& .hero-title, & .home-hero-title': {
          fontSize: '64px !important',
          fontWeight: 500,
          lineHeight: '71px',
          letterSpacing: '-1.28px !important',
          '& sup': {
            fontSize: '0.4em',
            lineHeight: 1,
            verticalAlign: 'super',
          },
          '@media (min-width: 900px) and (max-width: 1300px)': {
            fontSize: '52px !important',
            lineHeight: '64px !important',
          },
          '@media (max-width: 900px) and (min-width: 600px)': {
            fontSize: '48px !important',
            lineHeight: '56px !important',
          },
          '@media (max-width: 600px)': {
            fontSize: '42px !important',
            lineHeight: '48px !important',
          },
        },
        '& .hero-subtitle, & .home-hero-subtitle': {
          fontWeight: 400,
          fontSize: 18,
          lineHeight: '24px',
          maxWidth: 600,
          letterSpacing: '-0.36px !important',
          color: palette.text.primary,
          '@media(min-width: 767px)': {
            fontSize: 18,
          },
          '@media (min-width: 768px) and (max-width: 1024px)': {
            maxWidth: 'none',
            textAlign: 'left',
          },
          '@media (max-width: 600px)': {
            fontSize: '16px !important',
            lineHeight: '24px !important',
          },
        },
      },
      '& .section-header': {
        '@media (max-width: 900px)': {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
      '& .section-header__title-wrapper': {
        maxWidth: '600px !important',
        paddingLeft: '56px !important',
        '@media(max-width: 900px)': {
          display: 'flex',
          justifyContent: 'center',
          paddingLeft: '0px !important',
        },
      },
      '& .section-header__subtitle-wrapper': {
        maxWidth: '600px !important',
        paddingInline: '56px !important',
      },
      '& .section-header__cta-wrapper': {
        width: '100%',
        paddingLeft: '56px !important',
        maxWidth: '600px !important',
        '@media (max-width: 900px) and (min-width: 600px)': {
          paddingLeft: '0px !important',
        },
        '@media (max-width: 600px)': {
          paddingInline: '28px !important',
        },
        '& .section-header__cta-container': {
          '& .section-header__cta-item-wrapper': {
            width: '100%',
            '@media (min-width: 900px) and (max-width: 1300px)': {
              paddingRight: '50px !important',
            },
            '& button': {
              width: '220px',
              '@media (max-width: 1300px)': {  
                width: '100%',
              },
            },
            '& .MuiButton-outlined': {
              '@media (min-width: 900px) and (max-width: 1300px)': {  
                marginLeft: '0px !important',
              },
            },
          },
        },

      },
      '& .image-wrapper': {
        padding: '0px 48px !important',
        paddingRight: '0px !important',
        overflow: 'hidden',
        paddingLeft: '0px !important',
        borderRadius: '24px',
        margin: '0 !important',
        padding: '0 !important',
        maxWidth: '100%',
        flexBasis: '50%',
        objectFit: 'cover',
        marginRight: '15px !important',
        height: '100% !important',
        '@media (min-width: 1024px)': {
          display: 'flex !important',
          justifyContent: 'right !important',
        },
        '@media (min-width: 900px) and (max-width: 1300px)': {
          minHeight: 600,
          height: 'auto',
          marginRight: '20px !important',
        },
        '@media (max-width: 900px) and (min-width: 600px)': {
          minWidth: 400,
          width: 'auto',
          paddingBottom: '40px !important',
        },
        '@media (max-width: 600px)': {
          minWidth: '100vw',
          width: 'auto',
        },
        '& .image': {
          width: '100%',
          height: '100%',
          maxWidth: '80vw',
          maxHeight: 'none',
          objectFit: 'cover',
          boxShadow: 'none',
          display: 'block',
          borderRadius: '0px 24px 24px 0px !important',
          '@media (max-width: 600px)': {
            maxWidth: '90vw',
          },
          '@media (max-width: 900px) and (min-width: 600px)': {
            maxWidth: '80vw',
          },
        },
        '@media(max-width: 1300px)': {
          display: 'flex',
          justifyContent: 'center',
          marginRight: '0px !important',
        },
      },
      '@media(min-width: 900px)': {
        '& .section-alternate__content': {
          paddingTop: 34,
        },
        maxHeight: '740px',
      },
      '@media(max-width: 900px)': {
        '& .hero-title, .hero-subtitle, .home-hero-title, .home-hero-subtitle': {
          textAlign: 'center',
        },
        '& .section-header__cta-wrapper': {
          '& .section-header__cta-container': {
            '& .section-header__cta-item-wrapper': {
              width: '100%',
              '@media (min-width: 768px) and (max-width: 1024px)': {
                display: 'flex',
              },
            },
          },
        },
      },
    },

    /* Benefits - Styles */
    '& .definition-Wrapper': {
      paddingTop: '64px !important',
      '& .section-alternate': {
        maxWidth: '1440px !important',
        margin: '0 0 !important',
      },
      '& .section-alternate__content': {
        padding: '0px 0px !important',
      },
      '& .definition-service-description-wrapper': {
        display: 'flex',
        justifyContent: 'center',
      },
      '& .definition-variant-2': {
        padding: '0 !important',
        maxWidth: '1440px !important',
      },
      '& .definition-benefits-grid': {
        display: 'flex',
        justifyContent: 'space-around',
        '& .definition-service-tile': {
          maxWidth: '500px',
          width: '100%',
          '@media (max-width: 900px) and (min-width: 600px)': {
            maxWidth: '800px !important',
          },
        },
      },
      '& .definition-service-innertile': {
        backgroundColor: palette.background.main,
        padding: '40px 24px !important',
        borderRadius: '24px !important',
        '& .image':{
          paddingBottom: 40,
        },
        '& .definition-service-title': {
          fontFamily: 'Europa !important',
          fontSize: '24px !important',
          lineHeight: '32px !important',
          letterSpacing: '-0.48px !important',
          fontWeight: 500,
          color: palette.text.primary,
        },
      },
      '& .benefits-wrapper': {
        padding: '5px !important',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        '& .section-header': {
          maxWidth: 928,
          '@media (max-width: 900px) and (min-width: 600px)': {
            maxWidth: '660px !important',
          },
          '& .section-header__title': {
            fontWeight: 500,
            fontSize: '56px !important',
            lineHeight: '72px !important',
            letterSpacing: '0px !important',
            color: palette.text.primary,
            '@media (min-width: 900px) and (max-width: 1300px)': {
              fontSize: '48px !important',
              lineHeight: '64px !important',
              maxWidth: '800px !important',
            },
            '@media (max-width: 900px) and (min-width: 600px)': {
              fontSize: '42px !important',
              lineHeight: '48px !important',
            },
            '@media (max-width: 600px)': {
              fontSize: '36px !important',
              lineHeight: '48px !important',
            },
          },
          paddingBottom: 40,
        },
        '& .definition-service-description': {
          maxWidth: 380,
          paddingTop: 14,
          color: palette.text.tertiary,
          fontSize: '16px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.32px !important',
          fontWeight: 400,
          fontFamily: 'Europa !important',
          '@media (max-width: 900px) and (min-width: 600px)': {
            maxWidth: '600px !important',
          },
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      '& .subscription-bg': {
        height: '100%',
        background: 'none !important',
      },
      '& .cardTopRibbon': {
        background: palette.primary.main,
        color: palette.text.highlight,
      },
      '& .section-header__title, .summary-text, .summary-subtext':
      {
        color: `${palette.text.primary} !important`,
      },
      '& .section-header__subtitle': {
        color: `${palette.text.tertiary} !important`,
      },
      '& #pricing-benefit-section': {
        boxSizing: 'border-box',
        '& .react-multi-carousel-list': {
          paddingBottom: '32px !important',
        },
        '& .planCard': {
          border: 'none',
          borderRadius: '12px !important',
          backgroundColor: palette.background.planCard,
          '& .bold': {
            color: palette.text.primary,
          },
          '& .customGetStarted': {
            minHeight: '53px !important',
            boxSizing: 'border-box !important',
          },
          '& .plan-card-disclaimer-row .disclaimerContainer .annual-savings-disclaimer, & .plan-card-disclaimer-row .disclaimerContainer .plan-disclaimer-text': {
            color: `${palette.text.tertiary} !important`,
          },
          '& .plan-card-disclaimer-row .disclaimerContainer > .MuiGrid-item': {
            paddingBottom: '0 !important',
          },
          '& .fullHeight': {
            alignContent: 'space-between !important',
          },
          '& .plan-card-disclaimer-row .plan-card-disclaimer-divider': {
            display: 'none !important',
          },
          '& .plan-card-disclaimer-row .disclaimerContainer .plan-disclaimer-text': {
            display: 'block',
            marginTop: '40px !important',
            paddingTop: '16px !important',
            borderTop: `1px solid ${palette.divider} !important`,
          },
          '& .customCardTitle, .perksTitle': {
            fontFamily: 'Dela Gothic One'
          },
          '&:hover': {
            color: palette.text.primary,
            background: palette.background.planCard,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.disabled,
          },
          '& .MuiButton-containedSecondary': {
            '&:hover': {
              opacity: 1,
            },
          },
          '& .planCardDescription': {
            height: 'auto',
          },
          '& .customButtonWrapper': {
            paddingRight: '20px !important',
          },
          '& .customBenefitsContainer': {
            minHeight: 'auto !important',
          },
        },
        '& .subscription-section': {
          padding: ' 40px 40px !important',
          backgroundColor: palette.background.main,
          borderRadius: 24,
          maxWidth: '1440px !important',
          '& .section-header': {
            maxWidth: 720,
            '& .section-header__title': {
              fontSize: '48px !important',
              fontWeight: 500,
              lineHeight: '48px',
              letterSpacing: '0px !important',
              '@media (max-width: 600px)': {
                fontSize: '42px !important',
                lineHeight: '48px !important',
              },
            },
            '& .section-header__subtitle': {
              fontSize: '20px !important',
              fontWeight: 400,
              lineHeight: '20px',
              letterSpacing: '0px !important',
              color: palette.text.primary,
              '@media (max-width: 600px)': {
                fontSize: '18px !important',
                lineHeight: '24px !important',
              },
            },

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
          '& .plans-loader': {
            color: palette.text.highlight,
          },
        },
        '& .savings-summary-link': {
          color: palette.text.link,
          textDecoration: 'underline',
          cursor: 'pointer',
          fontSize: '20px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.4px !important',
          fontWeight: 400,
        },
        '& .summary-text': {
          display: 'none !important',
        },
        '& .summary-subtext': {
          color: palette.text.tertiary,
          fontSize: '20px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.4px !important',
          fontWeight: 400,
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: 'none !important',
      '& .section': {
        paddingInline: '0px !important',
      },
      '& .howitworks-title': {
        marginBottom: 40,
      },

      '& .howitworks-wrapper': {
        padding: '0px 20px !important',
        paddingRight: '0px !important',
        borderRadius: '24px !important',
        backgroundColor: palette.background.main,
        maxWidth: 1440,
        '& .howitworks-grid': {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'stretch',
          width: '100%',
          margin: '0 auto !important',
          '@media (max-width: 900px) and (min-width: 600px)': {
            padding: '40px 40px !important',
          },
          '@media (max-width: 600px)': {
            padding: '24px 24px !important',
          },
        },
        '& .section-header__title': {
          fontSize: '48px !important',
          fontWeight: 500,
          lineHeight: '72px !important',
          letterSpacing: '-0.96px !important',
        },
        '& .section-header__subtitle': {
          fontSize: '20px !important',
          fontWeight: 400,
          lineHeight: '20px !important',
          letterSpacing: '0px !important',
          color: palette.text.tertiary,
        },
      },
      '& .cover-image-wrapper': {
        padding: '0px 0px !important',
        overflow: 'hidden',
        height: '100%',
        display: 'flex',
        alignItems: 'stretch',
        '@media (min-width: 1300px)': {
          minHeight: 650,
          height: 'auto',
        },
        '@media (min-width: 768px) and (max-width: 1024px)': {
          minHeight: 500,
          height: 'auto',
        },
        '@media (min-width: 1024px) and (max-width: 1300px)': {
          minHeight: 600,
          height: 'auto',
        },
        '@media (max-width: 600px)': {
          minWidth: '300px',
          height: 'auto',
        },
        '@media(max-width: 1300px)': {
          marginRight: '0px !important',
        },
      },

      '& .howitworks-wrapper-left': {
        padding: 40,
        '@media(min-width: 1300px)': {
          maxWidth: 580,
        },
      },

      '& .makeStyles-root-54': {
        padding: 0,
      },

      '& .how-cover-image': {
        width: '100%',
        height: '100%',
        minHeight: '100%',
        maxHeight: 'none',
        objectFit: 'cover',
        boxShadow: 'none',
        display: 'block',
        borderRadius: 24,
        '@media (max-width: 1300px) and (min-width: 900px)': {
          borderRadius: '0px 24px 24px 0px !important',
        },
        '@media (max-width: 900px)': {
          content: 'url(/images/home-images/how-it-works-mobile.webp)',
        },
      },

      '& .step-counter': {
        borderRadius: '50%',
        backgroundColor: palette.background.border,
        color: palette.text.highlight,
        fontSize: 15,
        fontFamily: 'Europa !important',
      },
      '& .working-steps-main-container': {
        '@media (max-width: 900px)': {
          paddingBottom: '40px !important',
        },
      },
      '& .working-steps-container': {
        paddingBottom: '0px !important',
        '& .step-title': {
          fontSize: 20,
          lineHeight: '32px',
          letterSpacing: '-0.4px !important',
          fontWeight: 400,
          fontFamily: 'Europa !important',
        },
        '& .step-content': {
          fontSize: 16,
          lineHeight: '24px',
          letterSpacing: '-0.32px !important',
          fontWeight: 400,
          fontFamily: 'Europa !important',
          color: palette.text.tertiary,
        },
      },

      '& .step-started-button': {
        '& .right-icon': {
          color: palette.text.highlight,
        },
      },

      '& .working-steps-container:not(:last-child)': {
        paddingBottom: 30,
      },

      '@media screen and (max-width: 900px)': {
        '& .howitworks-wrapper-left': {
          padding: '5px',
        },
      },

      '@media(min-width: 900px)': {
        '& .howitworks-wrapper-left': {
          paddingLeft: '40px',
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      paddingInline: '0px !important',
      width: '100%',
      maxWidth: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      '& .section': {
        maxWidth: 1280,
        borderRadius: '24px !important',
      },
      '& .savingsDataContainer': {
        paddingInline: '0px !important',
        maxWidth: 1280,
        width: '100%',
        '& .MuiInputAdornment-positionEnd': {
          background: 'transparent',
        },
        '& .MuiSelect-select, & .MuiSelect-select:focus': {
          backgroundColor: 'transparent !important',
        },
      },
      '& .savings-hero-section': {
        background: 'none !important',
        width: '100%',
        maxWidth: '1280px',
        '& .section': {
          backgroundColor: palette.background.main,
          maxWidth: 1280,
          width: '100%',
          height: 268,
          marginTop: '88px !important',
          borderRadius: '24px !important',
          padding: '40px 56px !important',
          backgroundImage: 'url(/images/hero-bg.webp)',
          backgroundPosition: 'right center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          '@media(max-width: 600px)': {
            height: '400px !important',
            backgroundPosition: 'bottom right !important',
          },
          '& .section-header': {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start !important',
            alignItems: 'center',
            '& .section-header__title-wrapper, & .section-header__subtitle-wrapper':
              {
                '& .hero-header-title': {
                  textAlign: 'left',
                  color: palette.text.primary,
                  fontWeight: '500 !important',
                  fontSize: '32px !important',
                  letterSpacing: '0px',
                  lineHeight: '32px',
                  fontFamily: "'Eighties Comeback', sans-serif !important",
                  '@media(max-width: 900px)': {
                    textAlign: 'center !important',
                    paddingLeft: '0px !important',
                  },
                },
                '& .hero-header-subtitle': {
                  marginLeft: '0px !important',
                  textAlign: 'left !important',
                  fontWeight: '400 !important',
                  fontSize: '18px !important',
                  fontFamily: 'Europa !important',
                  lineHeight: '22px',
                  letterSpacing: '-0.72px',
                  '@media(max-width: 900px)': {
                    textAlign: 'center !important',
                    paddingLeft: '0px !important',
                  },
                },
              },
          },
          '& .header-container': {
            display: 'flex',
            flexDirection: 'row-reverse',
            justifyContent: 'flex-end',
            marginRight: '20px !important',
            '@media(max-width: 600px)': {
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            },
            '& .MuiGrid-root': {
              '@media(max-width: 600px)': {
                width: '100% !important',
                maxWidth: '100% !important',
              },
            },  
          },
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          '@media screen and (max-width: 900px)': {
            '& .section-header': {
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center !important',
              alignItems: 'center',
              '& .section-header__title-wrapper, & .section-header__subtitle-wrapper':
                {
                  '& .hero-header-title': {
                    textAlign: 'center',
                    paddingLeft: '50px !important',
                    color: palette.text.tertiary,
                    fontWeight: '400 !important',
                    fontSize: '24px !important',
                    letterSpacing: '0px',
                    lineHeight: '32px',
                  },
                  '& .hero-header-subtitle': {
                    marginLeft: '0px !important',
                    paddingLeft: '50px !important',
                    textAlign: 'center !important',
                    fontWeight: '400 !important',
                    fontSize: '16px !important',
                    lineHeight: '22px',
                    letterSpacing: '-0.72px',
                  },
                },
            },
            display: 'flex',
            flexDirection: 'column',
          },
        },
        '& .hero-header-title, .hero-header-subtitle': {
          margin: '0',
          maxWidth: 'unset',
          fontFamily: "'Eighties Comeback', sans-serif !important",
          fontWeight: '400 !important',
          letterSpacing: '-0.2px',
        },
        '& .header-container': {
          '@media(max-width: 900px)': {
            justifyContent: 'center !important',
            paddingLeft: '20px !important',
            paddingRight: '15px !important',
          },
          margin: '0',
        },
        '@media screen and (max-width: 900px)': {
          '& .section': {
            marginTop: '10px',
            padding: '64px 24px !important',
          },
        },
      },
      '& .service-plan-table': {
        border: `1px solid ${palette.secondary.main}`,
        width: '100%',
        maxWidth: '1280px',
        '& .savings-header': {
          color: palette.text.primary,
        },
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        }
      },
      '& .savings-contact-card': {
        background: 'none !important',
        width: '100%',
        maxWidth: '1280px',
        paddingInline: '0px !important',
      },
      '& .faq-contact-section': {
        '& .contact-card-title': {
          fontSize: '48px !important',
          lineHeight: 'normal !important',
          letterSpacing: '-0.96px !important',
          fontWeight: 500,
          '@media(max-width: 600px)': {
            fontSize: '36px !important',
            lineHeight: '48px !important',
          },
        },
        '& .contact-card-subtitle': {
          fontSize: '20px !important',
          fontWeight: 400,
          color: palette.text.tertiary,
          '@media(max-width: 600px)': {
            fontSize: '16px !important',
            lineHeight: '22px !important',
          },
        },
        padding: '56px !important',
        borderRadius: '24px !important',
        color: palette.text.primary,
        background: palette.background.main,
        width: '100%',
        maxWidth: '1440px !important',
        '@media(max-width: 600px)': {
          paddingInline: '20px !important',
        },
        '& .contact-img-wrapper': {
          width: '72px',
          maxWidth: '72px',
        },
        '& .provider-contact-details': {
          fontSize: '16px !important',
          lineHeight: '18px !important',
          letterSpacing: '-0.36px !important',
          fontWeight: 400,
          color: palette.text.tertiary,
          fontFamily: 'Europa !important',
          paddingTop: '8px !important',
        },
        '& .provider-contact-link': {
          fontSize: '20px !important',
          lineHeight: '20px !important',
          letterSpacing: '-0.36px !important',
          fontWeight: 500,
          color: palette.text.primary,
          fontFamily: 'Eighties Comeback !important',
          '@media(max-width: 600px)': {
            fontSize: '18px !important',
          },
        },
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      overflowX: 'hidden',
      marginBottom: 56,
      '& .hero-static-bg': {
        margin: '0 auto',
        display: 'block',
        maxWidth: 1610,
        width: '100%',
        boxSizing: 'border-box',
        paddingLeft: 70,
        paddingRight: 70,
        background: 'none !important',
        '@media (max-width: 1200px)': {
          paddingLeft: 48,
          paddingRight: 48,
        },
        '@media (max-width: 900px)': {
          padding: 24,
          marginBottom: '0px !important',
        },
        '@media (max-width: 600px)': {
          paddingLeft: 16,
          paddingRight: 16,
        },
      },
      '& .hero-static-section-grid': {
        backgroundColor: palette.background.fill2,
        padding: '0px 0px !important',
        height: '100%',
        '& .section-header': {
          padding: '56px 56px !important',
          '@media (min-width: 600px) and (max-width: 900px)': {
            padding: '40px 32px !important',
          },
          '@media (max-width: 900px) and (min-width: 600px)': {
            paddingBottom: '0px !important',
            height: '100% !important',
          },
          '@media (max-width: 600px)': {
            padding: '24px 24px !important',
            paddingBottom: '0px !important',
          },
        },
        '@media (max-width: 900px)': {
          paddingBottom: '40px !important',
        },
      },
      '& .section-alternate': {
        position: 'relative',
        borderRadius: 24,
        padding: '0px 0px !important',
        maxWidth: 1480,
        width: '100%',
        boxSizing: 'border-box',
        '@media (max-width: 600px)': {
          marginBottom: 24,
        },
        '@media (max-width: 900px) and (min-width: 600px)': {
          marginBottom: '0px !important',
        },
      },
      '& .section-alternate__content': {
        position: 'relative',
        zIndex: 1,
        minWidth: '100%',
        padding: '0px 0px !important',
      },
      '& .hero-button-wrapper': {
        width: '250px',
        '@media (min-width: 900px) and (max-width: 1300px)': {
          paddingRight: '40px !important',
          paddingTop: '0px !important',
        },
        '@media (min-width: 600px) and (max-width: 900px)': {
          width: '100%',
          paddingRight: '32px !important',
          paddingLeft: '32px !important',
          paddingBottom: '0px !important',
        },
        '@media (max-width: 600px)': {
          width: '100%',
          paddingRight: '16px !important',
          paddingLeft: '16px !important',
          paddingBottom: '0px !important',
        },
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      background: 'none !important',
      paddingInline: '0px !important',
      paddingTop: '100px !important',
      width: '100%',
      maxWidth: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      '& .plan-selection-section': {
        maxWidth: '1280px !important',
        width: '100%',
        '& .section': {
          padding: '40px 56px !important',
          backgroundColor: palette.background.main,
          borderRadius: 24,
          marginTop: '88px !important',
          width: '100%',
          boxSizing: 'border-box',
          '@media(max-width: 600px)': {
            marginBottom: '40px !important',
          },
          '& .header-container': {
            '@media(max-width: 600px)': {
              '& .MuiGrid-root': {
                '@media(max-width: 600px)': {
                  minWidth: '250px !important',
                  width: '100% !important',
                },
              },
              '@media(max-width: 600px)': {
                paddingBottom: '10px !important',
              },
            },
          },
        },
      },
      '& .plan-selection-main-container': {
        maxWidth: '1280px !important',
        width: '100%',
        backgroundColor: palette.background.main,
        borderRadius: 24,
        marginBottom: 80,
        boxSizing: 'border-box',
      },
      '& .home-static-hero-wrapper': {
        maxWidth: '1280px !important',
      },
      '& .find-provider-section': {
        maxWidth: '1280px !important',
        width: '100%',
        justifyContent: 'center',
        '@media(max-width: 600px)': {
          marginBottom: '40px !important',
        },
        '& .section': {
          padding: '50px 60px !important',
          paddingTop: '50px !important',
          marginTop: '72px !important',
          maxWidth: '1280px !important',
          width: '100%',
          height: 'auto% !important',
          borderRadius: '24px !important',
          backgroundColor: palette.background.main,
          '& .section-header': {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start !important',
            alignItems: 'center',
            marginBottom: '0px !important',
            '& .section-header__title-wrapper, & .section-header__subtitle-wrapper':
              {
                '& .hero-header-title': {
                  textAlign: 'left',
                  paddingLeft: '20px !important',
                  color: palette.text.tertiary,
                  fontWeight: '500 !important',
                  fontSize: '40px !important',
                  letterSpacing: '0px',
                  fontFamily: "'Eighties Comeback', sans-serif !important",
                  lineHeight: '40px',
                  '@media(max-width: 1024px)': {
                    textAlign: 'center !important',
                    paddingLeft: '0px !important',
                  },
                },
                '& .hero-header-subtitle': {
                  marginLeft: '0px !important',
                  paddingLeft: '20px !important',
                  textAlign: 'left !important',
                  fontWeight: '400 !important',
                  fontSize: '18px !important',
                  lineHeight: '22px',
                  letterSpacing: '-0.72px',
                  '@media(max-width: 1024px)': {
                    textAlign: 'center !important',
                    paddingLeft: '0px !important',
                    marginLeft: 'auto !important',
                    marginRight: 'auto !important',
                  },
                },
              },
          },
          '& .header-container': {
            display: 'flex',
            flexDirection: 'row-reverse',
            justifyContent: 'flex-start',
            paddingBottom: '10px !important',
          },
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          '@media screen and (max-width: 1024px)': {
            '& .section-header': {
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center !important',
              alignItems: 'center',
              '& .section-header__title-wrapper, & .section-header__subtitle-wrapper':
                {
                  '& .hero-header-title': {
                    textAlign: 'center',
                    paddingLeft: '50px !important',
                    color: palette.text.tertiary,
                    fontWeight: '500 !important',
                    fontSize: '40px !important',
                    letterSpacing: '0px',
                    fontFamily: "'Eighties Comeback', sans-serif !important",
                    lineHeight: '32px',
                  },
                  '& .hero-header-subtitle': {
                    marginLeft: '0px !important',
                    paddingLeft: '50px !important',
                    textAlign: 'center !important',
                    fontWeight: '400 !important',
                    fontSize: '18px !important',
                    lineHeight: '22px',
                    letterSpacing: '-0.72px',
                  },
                },
            },
            '& .header-container': {
              margin: '0px !important',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              paddingTop: '10px',
              paddingBottom: '40px',
              '& .MuiGrid-root': {
                '@media(max-width: 600px)': {
                  minWidth: '250px !important',
                  width: '100% !important',
                },
              },
              '@media(max-width: 600px)': {
                paddingBottom: '10px !important',
              },
            },
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
          },
        },
      },
      /*
       * Find a provider — zipcode label / placeholder (e.g. ES "Ingrese el código postal"): 12px on mobile.
       * V1: InputLabel for="#zip-code-input" in main container; V2: placeholder in hero filter-container.
       */
      '& .find-provider-section ~ .checkout-flow-main-container': {
        '@media(max-width: 600px)': {
          '& label[for="zip-code-input"].MuiInputLabel-outlined': {
            fontSize: '0.60rem !important',
          },
          /* Shrink uses scale(0.75); neutralize so effective size stays 0.75rem (12px at 16px root). */
          '& label[for="zip-code-input"].MuiInputLabel-outlined.MuiInputLabel-shrink': {
            fontSize: '0.60rem !important',
            transform: 'translate(14px, -6px) scale(1) !important',
          },
          /* Location name (e.g. ES "Nombre de la ubicación") — match small mobile label size */
          '& .MuiFormControl-root:has([data-testid="filter-search-location-name"]) .MuiInputLabel-outlined':
            {
              fontSize: '0.60rem !important',
            },
          '& .MuiFormControl-root:has([data-testid="filter-search-location-name"]) .MuiInputLabel-outlined.MuiInputLabel-shrink':
            {
              fontSize: '0.60rem !important',
              transform: 'translate(14px, -6px) scale(1) !important',
            },
        },
      },
      '& .find-provider-section ~ .filter-container': {
        '@media(max-width: 600px)': {
          '& #zip-code-input::placeholder': {
            fontSize: '0.60rem',
            opacity: 1,
          },
        },
      },
      '& .checkout-flow-main-container': {
        backgroundColor: palette.background.main,
        width: '100%',
        maxWidth: 1280,
        marginBottom: 160,
        borderRadius: 24,
        '& .zipcode-filter': {
          '@media (min-width: 600px) and (max-width: 1024px)': {
            flexBasis: '100% !important',
            maxWidth: 'none !important',
            width: '100% !important',
          },
        },
        '& .provider-list-wrapper': {
          '@media (max-width: 1024px)': {
            flexBasis: '100% !important',
            maxWidth: '100% !important',
          },
          '@media (min-width: 1025px)': {
            flexBasis: '0 !important',
            maxWidth: 'none !important',
            flexGrow: '1 !important',
            minWidth: 0,
          },
        },
        '& .provider-map-wrapper': {
          '@media (max-width: 1024px)': {
            flexBasis: '100% !important',
            maxWidth: '100% !important',
          },
          '@media (min-width: 1025px)': {
            flexBasis: '50% !important',
            maxWidth: '50% !important',
          },
        },
        '& .card-wrapper': {
          '@media (max-width: 1024px)': {
            flexBasis: '100% !important',
            maxWidth: '100% !important',
          },
        },
        /*
         * Provider card row: 50/50 from sm so CTA gets half the card (percent-based, no fixed button width).
         */
        '& .card-wrapper .MuiGrid-container.MuiGrid-spacing-xs-2 > .MuiGrid-item.MuiGrid-grid-sm-9.MuiGrid-grid-md-8':
          {
            '@media (min-width: 600px)': {
              flexBasis: '50% !important',
              maxWidth: '50% !important',
            },
          },
        '& .card-wrapper .MuiGrid-container.MuiGrid-spacing-xs-2 > .MuiGrid-item.MuiGrid-grid-sm-3.MuiGrid-grid-md-4':
          {
            '@media (min-width: 600px)': {
              flexBasis: '50% !important',
              maxWidth: '50% !important',
            },
          },
        '& .card-wrapper button[data-testid^="select-office-button"]': {
          '@media (min-width: 900px)': {
            whiteSpace: 'nowrap',
            '& .MuiButton-label': {
              whiteSpace: 'nowrap',
            },
          },
        },
      },
      '& .checkout-outer-container': {
        width: '100%',
        maxWidth: '1280px',
        boxSizing: 'border-box',
        '& .payment-title-root': {
          marginTop: 0,
        },
        '& .promo-spinner': {
          backgroundColor: 'unset',
        },
        '& .termsText': {
          fontFamily: 'none',
          fontWeight: 'bold'
        },
        '& .checkout-hero-section': {
          width: '100%',
          marginTop: '88px !important',
          '& .section':{
            backgroundColor: palette.background.main,
            borderRadius: 24,
            width: '100%',
            boxSizing: 'border-box',
            padding: '40px 56px !important',
          }
        },
        '& .checkout-innner-container': {
          width: '100%',
          boxSizing: 'border-box',
          backgroundColor: palette.background.main,
          borderRadius: 24,
          marginBottom: 160,
          paddingBottom: '0 !important',
          '& .section': {
            padding: '40px !important',
            width: '100%',
            boxSizing: 'border-box',
          },
          '& .customDetailsContainer': {
            '& .add-dependent-button': {
              width: '200px !important',
            },
          },
        },
      },
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
        /* Text buttons: global MuiButton ::after arrow + tight label padding clips longer copy (e.g. ES "Editar ubicación"). */
        '& .customEditButton': {
          flexShrink: 0,
          overflow: 'visible',
          '& .MuiButton-label': {
            paddingRight: '3em !important',
            overflow: 'visible',
            whiteSpace: 'nowrap',
          },
        },
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
      '& .MuiSwitch-thumb': {
        background: palette.text.highlight,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.primary.main,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        background: palette.secondary.main,
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        /* MFE FrequencyPlans always renders switch in tabVariant 1 else-branch; hide for AD. Tabs (when multiple freqs) unchanged. */
        '& .switch-box': {
          display: 'none !important',
        },
        '& .planCard': {
          border: `1px solid ${palette.text.primary}`,
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.highlight,
          },
          '& .planCardDescription': {
            height: 'auto',
          },
        },
      },
    },

    /* FAQ */
    '& .faq-wrapper': {
      backgroundColor: palette.background.fill,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      maxWidth: '100%',
      paddingInline: '0px !important',
      '& .section': {
        maxWidth: '1280px !important',
        backgroundColor: palette.background.main,
      },
      '& .faqInnerContainer': {
        paddingInline: '0px !important',
        background: 'none !important',
        width: '100%',
        maxWidth: '1280px',
        '& .MuiTabs-root': {
          backgroundColor: `${palette.background.main} !important`,
          padding: '16px !important',
          borderRadius: '24px !important',
          '& .MuiButtonBase-root': {
            padding: '18px 24px !important',
            borderRadius: '24px !important',
            '&:hover': {
              backgroundColor: `${palette.background.main} !important`,
            },
          },
        },
      },
      '& .faq-hero-section': {
        justifyContent: 'center',
        width: '100%',
        maxWidth: '1280px',
        '& .section': {
          padding: '10px 30px !important',
          paddingTop: '50px !important',
          marginTop: '182px !important',
          maxWidth: '1280px !important',
          width: '100%',
          height: 'auto !important',
          borderRadius: '24px !important',
          backgroundColor: palette.background.main,
          '@media (max-width: 420px)': {
            marginTop: '220px !important',
          },
        },
        '& .faq-hero-internal': {
          '& .section-header': {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start !important',
            alignItems: 'center',
            '& .section-header__title-wrapper, & .section-header__subtitle-wrapper':
              {
                '& .hero-header-title': {
                  textAlign: 'left',
                  paddingLeft: '20px !important',
                  color: palette.text.tertiary,
                  fontWeight: '500 !important',
                  fontSize: '40px !important',
                  letterSpacing: '0px',
                  fontFamily: "'Eighties Comeback', sans-serif !important",
                  lineHeight: 'normal',
                  '@media(max-width: 900px)': {
                    textAlign: 'center !important',
                  },
                },
                '& .hero-header-subtitle': {
                  marginLeft: '0px !important',
                  paddingLeft: '20px !important',
                  textAlign: 'left !important',
                  fontWeight: '400 !important',
                  fontSize: '18px !important',
                  lineHeight: '24px',
                  letterSpacing: '-0.72px',
                  fontFamily: 'Europa !important',
                  '@media(max-width: 900px)': {
                    textAlign: 'center !important',
                  },
                },
              },
          },
          '& .header-container': {
            display: 'flex',
            flexDirection: 'row-reverse',
            justifyContent: 'flex-start',
            '@media(max-width: 600px)': {
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            },
            '& .MuiGrid-root': {
              '@media(max-width: 600px)': {
                width: '100% !important',
                maxWidth: '100% !important',
              },
            },  
          },
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          '@media screen and (max-width: 900px)': {
            '& .section-header': {
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center !important',
              alignItems: 'center',
              '& .section-header__title-wrapper, & .section-header__subtitle-wrapper':
                {
                  '& .hero-header-title': {
                    textAlign: 'center',
                    paddingLeft: '50px !important',
                    color: palette.text.tertiary,
                    fontWeight: '400 !important',
                    fontSize: '24px !important',
                    letterSpacing: '0px',
                    lineHeight: '32px',
                  },
                  '& .hero-header-subtitle': {
                    marginLeft: '0px !important',
                    paddingLeft: '50px !important',
                    textAlign: 'center !important',
                    fontWeight: '400 !important',
                    fontSize: '16px !important',
                    lineHeight: '22px',
                    letterSpacing: '-0.72px',
                  },
                },
            },
            display: 'flex',
            flexDirection: 'column',
          },
        },
        '& .hero-header-title, .hero-header-subtitle': {
          margin: '0',
          maxWidth: 'unset',
          fontFamily: 'Poppins, sans-serif !important',
          fontWeight: '400 !important',
          letterSpacing: '-0.2px',
        },
        '& .header-container': {
          '@media(max-width: 900px)': {
            justifyContent: 'center !important',
            paddingLeft: '10px !important',
            paddingRight: '15px !important',
          },
          margin: '0',
        },
        '@media screen and (max-width: 900px)': {
          '& .faq-hero-internal': {
            marginTop: '10px',
            padding: '64px 24px !important',
          },
        },
      },
      '& .accordion__collapsable-text': {
        color: `${palette.text.tertiary} !important`,
      },
      '& .accorion__item-title-container': {
        '& .MuiTypography-subtitle1': {
          fontSize: '18px !important',
        },
      },
      '& .faq-contact-wrapper': {
        maxWidth: '1280px !important',
        width: '100%',
        borderRadius: '24px !important',
        marginBottom: '64px !important',
        '& .faq-contact-section': {
          '& .contact-card-title': {
            fontSize: '48px !important',
            lineHeight: 'normal !important',
            letterSpacing: '-0.96px !important',
            fontWeight: 500,
            '@media(max-width: 600px)': {
              fontSize: '36px !important',
              lineHeight: '48px !important',
            },
          },
          '& .contact-card-subtitle': {
            fontSize: '20px !important',
            fontWeight: 400,
            color: palette.text.tertiary,
            '@media(max-width: 600px)': {
              fontSize: '16px !important',
              lineHeight: '22px !important',
            },
          },
          padding: '56px !important',
          borderRadius: '24px !important',
          color: palette.text.primary,
          background: palette.background.main,
          width: '100%',
          maxWidth: '1280px !important',
          '@media(max-width: 600px)': {
            paddingInline: '20px !important',
          },
          '& .contact-img-wrapper': {
            width: '72px',
            maxWidth: '72px',
          },
          '& .provider-contact-details': {
            fontSize: '16px !important',
            lineHeight: '18px !important',
            letterSpacing: '-0.36px !important',
            fontWeight: 400,
            color: palette.text.tertiary,
            fontFamily: 'Europa !important',
            paddingTop: '8px !important',
          },
          '& .provider-contact-link': {
            fontSize: '20px !important',
            lineHeight: '20px !important',
            letterSpacing: '-0.36px !important',
            fontWeight: 500,
            color: palette.text.primary,
            fontFamily: 'Eighties Comeback !important',
            '@media(max-width: 600px)': {
              fontSize: '18px !important',
            },
          },
        },
      },
    },

    '& .success-wrapper': {
      '& .cancel-button': {
        backgroundColor: palette.text.highlight,
        borderRadius: '24px !important',
        border: `1px solid ${palette.secondary.border}`,
        color: palette.text.primary,
      },
    },
    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      marginBottom: '32px !important',
      maxWidth: '1280px !important',
      width: '100%',
      borderRadius: '24px !important',
      marginBottom: '64px !important',
      background: 'none !important',
      '& .faq-contact-section': {
        '& .contact-card-title': {
          fontSize: '48px !important',
          lineHeight: 'normal !important',
          letterSpacing: '-0.96px !important',
          fontWeight: 500,
          '@media(max-width: 600px)': {
            fontSize: '36px !important',
            lineHeight: '48px !important',
          },
        },
        '& .contact-card-subtitle': {
          fontSize: '20px !important',
          fontWeight: 400,
          color: palette.text.tertiary,
          '@media(max-width: 600px)': {
            fontSize: '16px !important',
            lineHeight: '22px !important',
          },
        },
        padding: '56px !important',
        borderRadius: '24px !important',
        color: palette.text.primary,
        background: palette.background.main,
        width: '100%',
        maxWidth: '1280px !important',
        '@media(max-width: 600px)': {
          paddingInline: '20px !important',
        },
        '& .contact-img-wrapper': {
          width: '72px',
          maxWidth: '72px',
        },
        '& .provider-contact-details': {
          fontSize: '16px !important',
          lineHeight: '18px !important',
          letterSpacing: '-0.36px !important',
          fontWeight: 400,
          color: palette.text.tertiary,
          fontFamily: 'Europa !important',
          padding: '8px 0px !important',
        },
        '& .provider-contact-link': {
          fontSize: '20px !important',
          lineHeight: '20px !important',
          letterSpacing: '-0.36px !important',
          fontWeight: 500,
          color: palette.text.primary,
          fontFamily: 'Eighties Comeback !important',
          '@media(max-width: 600px)': {
            fontSize: '18px !important',
            overflowWrap: 'anywhere',
          },
        },
      },
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
    },

    //* Stepper - styles */
    '& .customStepperRoot': {
      '& .MuiStepConnector-root': {
        '@media(max-width: 600px)': {
          paddingInline: '30px !important',
        },
      },
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.surface.light,
        color: palette.surface.light,
      },
    },

    // Stepper Icon Styles - Completed vs Uncompleted
    '& .MuiStepIcon-root': {
      color: 'transparent', // Default: transparent background
      width: 32,
      height: 32,
      borderColor: palette.primary.main,
      '@media(max-width: 600px)': {
        display: 'block',
      },

      // Completed step - filled circle with checkmark
      '&.MuiStepIcon-completed': {
        fill: `${palette.primary.main} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.primary.main,
        },
      },

      // Active step - filled circle with number
      '&.MuiStepIcon-active': {
        fill: `${palette.primary.main} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.primary.main,
        },
        '& .MuiStepIcon-text': {
          fill: palette.text.highlight, // text on filled background
        },
      },

      // Uncompleted step - empty circle with number
      '&:not(.MuiStepIcon-completed):not(.MuiStepIcon-active)': {
        '& .MuiSvgIcon-root': {
          color: 'transparent',
        },
        '& .MuiStepIcon-text': {
          fill: palette.background.border, // Dark text on transparent background
        },
        borderColor: palette.background.border,
      },
    },

    // Stepper Label Styles
    '& .MuiStepLabel-label': {
      color: palette.text.primary,

      '&.MuiStepLabel-completed': {
        color: palette.text.primary,
        fontWeight: 500,
      },

      '&.MuiStepLabel-active': {
        color: palette.text.primary,
        fontWeight: 500,
      },
    },

    // Stepper Connector Line
    '& .MuiStepConnector-lineHorizontal': {
      borderColor: `${palette.surface.light} !important`,
      borderTopWidth: 2,
    },

    // Stepper Container Style
    '& .stepperContainer': {
      '@media(max-width: 900px)': {
        paddingInline: '20px !important',
        paddingTop: '20px !important',
      },
    },

    '& .stepperItems': {
      marginTop: 24,
    },
    
    '& .footer-wrapper': {
      paddingInline: '64px !important',
      backgroundColor: palette.background.fill,
      '@media (max-width: 600px)': {
        paddingInline: '24px !important',
      },
    },

    '& .dashboard-hero-section': {
      '& .section': {
        maxWidth: '1440px !important',
        width: '100%',
        backgroundColor: palette.background.main,
        marginTop: '88px !important',
        borderRadius: '24px !important',
      },
    },
    '& .dashboard-main-container': {
        '& .MuiButton-root::after': {
          display: 'none',
        },
        maxWidth: '1440px !important',
        paddingInline: '0px !important',
        '& .widget': {
          height: '100%',
        },
    },

    '& .hipaa-hero-section': {
      '& .section': {
        backgroundColor: palette.background.main,
        marginTop: '80px !important',
        borderRadius: '24px !important',
        backgroundImage: 'url(/images/hero-bg.webp)',
        backgroundPosition: 'right center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        '@media(max-width: 600px)': {
          marginBottom: '30px !important',
        },
        '& .hero-header-title': {
          textAlign: 'left !important',
          paddingLeft: '40px !important',
        },
      },
    },

    '& .terms-hero-section': {
      '& .section': {
        backgroundColor: palette.background.main,
        marginTop: '80px !important',
        borderRadius: '24px !important',
        backgroundImage: 'url(/images/hero-bg.webp)',
        backgroundPosition: 'right center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        '@media(max-width: 600px)': {
          marginBottom: '30px !important',
        },
        '& .hero-header-title': {
          textAlign: 'left !important',
          paddingLeft: '40px !important',
        },
      },
    },
    '& .terms-conditions-container': {
      backgroundColor: palette.background.main,
      borderRadius: '24px !important',
      width: '100%',
    },

    '& .privacy-policy-container': {
      backgroundColor: palette.background.main,
      borderRadius: '24px !important',
      maxWidth: '60vw !important',
      width: '100%',
      '@media(max-width: 1800px)': {  
        maxWidth: '90vw !important',
      },
    },

    '& .privacy-hero-section': {
      '& .section': {
        backgroundColor: palette.background.main,
        marginTop: '80px !important',
        borderRadius: '24px !important',
        backgroundImage: 'url(/images/hero-bg.webp)',
        backgroundPosition: 'right center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        '@media(max-width: 600px)': {
          marginBottom: '30px !important',
        },
        '& .hero-header-title': {
          textAlign: 'left !important',
          paddingLeft: '40px !important',
        },
      },
    },
  },
};
